module.exports = __webpack_public_path__ + "img/soccerboard02.cb6ca930.jpg";